import { render, staticRenderFns } from "./BottomSheetV2.vue?vue&type=template&id=d908550c&"
import script from "./BottomSheetV2.js?vue&type=script&scoped=true&lang=js&"
export * from "./BottomSheetV2.js?vue&type=script&scoped=true&lang=js&"
import style0 from "./BottomSheetV2.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports